
import React from 'react';
import { AlertTriangle, Quote, MessageCircle } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';

const PainPointEmphasis = () => {
  return (
    <div className="text-center mb-16 sm:mb-20">
      <div className="max-w-6xl mx-auto">
        {/* Main Quote Card */}
        <Card className="border-0 shadow-2xl bg-gradient-to-br from-white via-gray-50/80 to-white mb-8">
          <CardContent className="p-8 sm:p-12">
            <div className="flex flex-col sm:flex-row items-start justify-center gap-4 sm:gap-6 mb-8">
              <div className="flex-shrink-0 w-12 h-12 sm:w-16 sm:h-16 bg-gradient-to-br from-[#003a70] to-[#003a70]/80 rounded-2xl flex items-center justify-center shadow-lg mx-auto sm:mx-0">
                <Quote className="text-[#FEE6D8]" size={20} />
              </div>
              <div className="flex-grow max-w-4xl text-center sm:text-left">
                <blockquote className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-gray-800 font-light italic leading-[1.3] tracking-tight">
                  "It often feels like you're just{' '}
                  <span className="relative">
                    <span className="bg-gradient-to-r from-[#FEE6D8] to-[#FEE6D8]/70 px-2 sm:px-3 py-1 rounded-lg text-[#003a70] font-medium">
                      one more voice
                    </span>
                  </span>
                  {' '}in a very crowded room, doesn't it?"
                </blockquote>
              </div>
            </div>
          </CardContent>
        </Card>

        {/* Pain Point Cards Grid */}
        <div className="grid md:grid-cols-3 gap-6 mb-8">
          <Card className="group hover:shadow-xl transition-all duration-300 border-orange-200/50 hover:border-orange-300">
            <CardContent className="p-6 text-center">
              <div className="w-12 h-12 bg-orange-100 rounded-xl flex items-center justify-center mx-auto mb-4 group-hover:bg-orange-200 transition-colors">
                <AlertTriangle className="text-orange-600" size={24} />
              </div>
              <h3 className="font-semibold text-gray-900 mb-2">Competing on Price</h3>
              <p className="text-gray-600 text-sm">Always having to justify your rates</p>
            </CardContent>
          </Card>

          <Card className="group hover:shadow-xl transition-all duration-300 border-red-200/50 hover:border-red-300">
            <CardContent className="p-6 text-center">
              <div className="w-12 h-12 bg-red-100 rounded-xl flex items-center justify-center mx-auto mb-4 group-hover:bg-red-200 transition-colors">
                <MessageCircle className="text-red-600" size={24} />
              </div>
              <h3 className="font-semibold text-gray-900 mb-2">Struggling to Differentiate</h3>
              <p className="text-gray-600 text-sm">Lost in a sea of similar services</p>
            </CardContent>
          </Card>

          <Card className="group hover:shadow-xl transition-all duration-300 border-yellow-200/50 hover:border-yellow-300">
            <CardContent className="p-6 text-center">
              <div className="w-12 h-12 bg-yellow-100 rounded-xl flex items-center justify-center mx-auto mb-4 group-hover:bg-yellow-200 transition-colors">
                <AlertTriangle className="text-yellow-600" size={24} />
              </div>
              <h3 className="font-semibold text-gray-900 mb-2">Proving Value</h3>
              <p className="text-gray-600 text-sm">Starting from zero with every prospect</p>
            </CardContent>
          </Card>
        </div>

        {/* Bottom Emphasis Card */}
        <Card className="border-[#003a70]/20 bg-gradient-to-r from-[#003a70]/5 via-white to-[#FEE6D8]/10 shadow-xl">
          <CardContent className="p-8 sm:p-10 text-center">
            <div className="max-w-4xl mx-auto">
              <p className="text-lg sm:text-xl text-[#003a70] font-semibold leading-tight mb-4">
                Constantly having to{' '}
                <span className="bg-gradient-to-r from-[#003a70] to-[#003a70]/80 bg-clip-text text-transparent font-bold">
                  "prove" your value
                </span>
                {' '}from scratch with every new prospect.
              </p>
              <div className="flex items-center justify-center gap-3 mt-6">
                <div className="w-12 h-px bg-gradient-to-r from-transparent to-[#003a70]/40"></div>
                <div className="w-2 h-2 bg-[#FEE6D8] rounded-full border border-[#003a70]/30"></div>
                <div className="w-12 h-px bg-gradient-to-l from-transparent to-[#003a70]/40"></div>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default PainPointEmphasis;
